export default __webpack_public_path__ + "images/3dab47a4f135d9e57a1f17f07906e8c2.svg";